import { includes } from "ramda";

export default function getErrorCss(path, errors) {
  return includes(path, errors?.keys ?? []) ? "--error" : "";
}
